import { IClassname } from '@/lib/shared/model/classname';

export const Iron = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.3049 21.2712C30.3049 21.6101 30.1702 21.9352 29.9306 22.1748C29.691 22.4144 29.3659 22.5491 29.027 22.5491H2.33517C2.21201 22.5491 2.09145 22.5136 1.98803 22.4467C1.88461 22.3798 1.80272 22.2844 1.75222 22.1721C1.70172 22.0598 1.68477 21.9352 1.7034 21.8135C1.72203 21.6917 1.77545 21.578 1.85723 21.4859L7.32288 15.3365C8.52185 13.9878 9.99286 12.9084 11.6391 12.1692C13.2853 11.43 15.0695 11.0478 16.874 11.0479H30.3049V21.2712Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1362 1.46387H26.4712C27.4879 1.46387 28.4631 1.86778 29.1821 2.58675C29.901 3.30572 30.305 4.28084 30.305 5.29762V11.0482"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5259 11.048V9.13115C17.5259 8.96168 17.5932 8.79916 17.713 8.67934C17.8328 8.55951 17.9954 8.49219 18.1648 8.49219H23.2765C23.446 8.49219 23.6085 8.55951 23.7284 8.67934C23.8481 8.79916 23.9155 8.96168 23.9155 9.13115V11.048"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.31982 18.7158H30.305"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.94155 29.8977C7.76511 29.8977 7.62207 29.7547 7.62207 29.5783C7.62207 29.4018 7.76511 29.2588 7.94155 29.2588"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M7.94141 29.8977C8.11785 29.8977 8.26089 29.7547 8.26089 29.5783C8.26089 29.4018 8.11785 29.2588 7.94141 29.2588"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M11.7753 26.0638C11.5988 26.0638 11.4558 25.9208 11.4558 25.7443C11.4558 25.5678 11.5988 25.4248 11.7753 25.4248"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M11.7751 26.0638C11.9516 26.0638 12.0946 25.9208 12.0946 25.7443C12.0946 25.5678 11.9516 25.4248 11.7751 25.4248"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M17.5258 29.8977C17.3493 29.8977 17.2063 29.7547 17.2063 29.5783C17.2063 29.4018 17.3493 29.2588 17.5258 29.2588"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M17.5259 29.8977C17.7024 29.8977 17.8454 29.7547 17.8454 29.5783C17.8454 29.4018 17.7024 29.2588 17.5259 29.2588"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M17.5258 26.0638C17.3493 26.0638 17.2063 25.9208 17.2063 25.7443C17.2063 25.5678 17.3493 25.4248 17.5258 25.4248"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M17.5259 26.0638C17.7024 26.0638 17.8454 25.9208 17.8454 25.7443C17.8454 25.5678 17.7024 25.4248 17.5259 25.4248"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M23.2765 26.0638C23.1 26.0638 22.957 25.9208 22.957 25.7443C22.957 25.5678 23.1 25.4248 23.2765 25.4248"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M23.2766 26.0638C23.4531 26.0638 23.5961 25.9208 23.5961 25.7443C23.5961 25.5678 23.4531 25.4248 23.2766 25.4248"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M27.1103 29.8977C26.9338 29.8977 26.7908 29.7547 26.7908 29.5783C26.7908 29.4018 26.9338 29.2588 27.1103 29.2588"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M27.1104 29.8977C27.2868 29.8977 27.4298 29.7547 27.4298 29.5783C27.4298 29.4018 27.2868 29.2588 27.1104 29.2588"
        stroke="#22364A"
        strokeWidth="1.33"
      />
    </svg>
  );
};
